export const CheckIcon = (props: any) => (
  <svg
    width={10}
    height={11}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5 .625c-.883 0-1.703.223-2.46.668A4.798 4.798 0 0 0 .792 3.039 4.773 4.773 0 0 0 .125 5.5c0 .883.223 1.703.668 2.46a4.798 4.798 0 0 0 1.746 1.747A4.774 4.774 0 0 0 5 10.375c.883 0 1.703-.223 2.46-.668a4.798 4.798 0 0 0 1.747-1.746A4.773 4.773 0 0 0 9.875 5.5c0-.578-.086-1.09-.258-1.535l-.61.598a4.057 4.057 0 0 1-.445 3.023 3.94 3.94 0 0 1-1.476 1.476A4.057 4.057 0 0 1 5 9.626c-.75 0-1.445-.188-2.086-.563a3.94 3.94 0 0 1-1.477-1.476A4.057 4.057 0 0 1 .875 5.5c0-.75.188-1.445.563-2.086a3.94 3.94 0 0 1 1.476-1.477A4.057 4.057 0 0 1 5 1.375c.555 0 1.082.105 1.582.316.477.196.898.477 1.266.844l.527-.527A4.67 4.67 0 0 0 6.84.988 4.713 4.713 0 0 0 5 .625ZM9.23 2.23 5 6.46 3.395 4.856l-.54.54L4.73 7.27l.27.257.27-.257 4.5-4.5-.54-.54Z"
      fill="#333"
    />
  </svg>
);

export const CheckBoxIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3333 6L7.13325 11L5.33325 9"
      stroke="#666666"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.8333 2.5H3.83325C3.00482 2.5 2.33325 3.17157 2.33325 4V13C2.33325 13.8284 3.00482 14.5 3.83325 14.5H12.8333C13.6617 14.5 14.3333 13.8284 14.3333 13V4C14.3333 3.17157 13.6617 2.5 12.8333 2.5Z"
      stroke="#666666"
      strokeLinejoin="round"
    />
  </svg>
);
